const re = /\/$/;
function w(e) {
  return e == null ? void 0 : e.trim().replace(re, "");
}
function ne(e, t) {
  if (e === void 0)
    throw new Error(`Could not find hypermedia link for relationship, ${t}`);
}
function S(e, t) {
  var r;
  return (r = e.find((n) => n.rel === t)) == null ? void 0 : r.href;
}
function $(e, t) {
  var n;
  const r = (n = e.find((i) => i.rel === t)) == null ? void 0 : n.href;
  return ne(r, t), r;
}
const q = w(
  process.env.NEXT_PUBLIC_RIPL_PRIVATE_PREFIX ?? process.env.RIPL_PRIVATE_PREFIX ?? "/private"
), O = w(
  process.env.NEXT_PUBLIC_RIPL_PROFILE_V1_PATH ?? process.env.RIPL_PROFILE_V1_PATH ?? "/v1/profile"
), z = w(
  process.env.NEXT_PUBLIC_RIPL_ATTENUATE_V1_PATH ?? process.env.RIPL_ATTENUATE_V1_PATH ?? "/v1/token-attenuate"
), D = w(
  process.env.NEXT_PUBLIC_RIPL_V1_ROLE_PATH ?? process.env.RIPL_V1_ROLE_PATH ?? "/v1/role-switch"
), oe = w(
  process.env.NEXT_PUBLIC_RIPL_V1_REFRESH_PATH ?? process.env.RIPL_V1_REFRESH_PATH ?? "/v1/token-refresh"
);
var y = /* @__PURE__ */ ((e) => (e.Get = "get", e.Post = "post", e))(y || {});
const tt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Method: y,
  PRIVATE_PREFIX: q,
  V1_ATTENUATE_PATH: z,
  V1_PROFILE_PATH: O,
  V1_REFRESH_PATH: oe,
  V1_ROLE_PATH: D,
  findLink: S,
  findRequiredLink: $,
  sanitizePathComponent: w
}, Symbol.toStringTag, { value: "Module" }));
function I(e, t) {
  return o(e, "links", ae) && o(e, "data", t);
}
function ie(e, t) {
  if (!I(e, t))
    throw new Error("Response was not the expected shape!");
}
function s(e) {
  return typeof e == "string";
}
function G(e) {
  return typeof e == "number";
}
function m(e) {
  return (t) => Array.isArray(t) && t.every(e);
}
function U(e, t) {
  return (r) => e(r) || t(r);
}
function se(e) {
  return !0;
}
function o(e, t, r, n = !1) {
  return e !== null && typeof e == "object" && M(e, t, r, n);
}
function M(e, t, r, n = !1) {
  return n ? t in e ? r(e[t]) : !0 : t in e && r(e[t]);
}
function ae(e) {
  return Array.isArray(e) && e.every(ce);
}
function ce(e) {
  return o(e, "href", s) && o(e, "rel", s);
}
const ue = {
  checkValue: M
}, rt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __internal: ue,
  assertIsApiResponse: ie,
  hasField: o,
  ignoreApiResponsePayload: se,
  isApiResponse: I,
  isArrayOf: m,
  isEitherOf: U,
  isNumber: G,
  isString: s
}, Symbol.toStringTag, { value: "Module" }));
function de(e) {
  return o(
    e,
    "curricula",
    U(m(he), m(B))
  ) && o(
    e,
    "standards",
    U(m(s), m(X))
  );
}
function le(e) {
  return m(B)(e);
}
function fe(e) {
  return m(X)(e);
}
function he(e) {
  return o(e, "id", s) && o(e, "addOns", m(s));
}
function B(e) {
  return o(e, "id", s) && o(e, "addOns", m(pe)) && o(e, "name", s);
}
function pe(e) {
  return o(e, "id", s) && o(e, "name", s);
}
function X(e) {
  return o(e, "id", s) && o(e, "name", s);
}
function k(e) {
  return le(e) ? _e(e) : me(e);
}
function _e(e) {
  return {
    tag: T,
    data: e.map(({ id: t, name: r, addOns: n }) => ({ id: t, name: r, addOns: n }))
  };
}
function me(e) {
  return {
    tag: te,
    data: e.map(({ id: t, addOns: r }) => ({ id: t, addOns: r }))
  };
}
function N(e) {
  return fe(e) ? Ae(e) : Ee(e);
}
function Ae(e) {
  return {
    tag: T,
    data: e.map(({ id: t, name: r }) => ({ id: t, name: r }))
  };
}
function Ee(e) {
  return {
    tag: te,
    data: e
  };
}
const Re = {
  curriculaFromApi: k,
  standardsFromApi: N
}, nt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __internal: Re,
  curriculaFromApi: k,
  standardsFromApi: N
}, Symbol.toStringTag, { value: "Module" }));
function Te(e) {
  return o(e, "status", G) && o(e, "data", (t) => !0);
}
function we(e) {
  return o(e, "response", Te);
}
function b(e, t) {
  if (t instanceof R)
    return t;
  if (we(t)) {
    const { status: r, data: n } = t.response;
    return new R(e, r, n, t);
  } else
    return t;
}
class R extends Error {
  constructor(t, r, n, i) {
    super(`Received a non-success response, ${r}, from remote, ${t}`, { cause: i }), this.url = t, this.statusCode = r, this.payload = n, this.cause = i;
  }
}
class ve extends Error {
  constructor(t, r) {
    super(`Attempt to make a request to remote, ${t}, failed because of a local error.`, {
      cause: r
    }), this.url = t, this.cause = r;
  }
}
var K = /* @__PURE__ */ ((e) => (e.RIPL_API_URL = "ripl-api-url", e.RIPL_API_INTERNAL_URL = "ripl-api-internal-url", e.COGNITO_USER_POOL = "cognito-user-pool", e))(K || {});
class Pe extends Error {
  constructor(t, r) {
    super(`${Le(t)}${x(r)}`), this.config = t;
  }
}
function Le(e) {
  switch (e) {
    case "ripl-api-url":
      return "The RIPL API URL must be configured!";
    case "ripl-api-internal-url":
      return "The RIPL internal API URL must be configured!";
    case "cognito-user-pool":
      return "The Cognito user pool must be configured!";
    default:
      throw new Error(`Unsupported configuration, ${e}!`);
  }
}
var v = /* @__PURE__ */ ((e) => (e.Token = "token", e.ActiveRole = "active role", e))(v || {});
class g extends Error {
  /**
   * Constructs a base message indicating what was missing and allows each adapter to provide
   * additional details to help users correct any misconfigurations or bugs.
   */
  constructor(t, r, n) {
    super(
      `${J(t, r)} is required but was missing from the request!${x(n)}`
    ), this.source = t, this.kind = r;
  }
}
function J(e, t) {
  switch (e) {
    case E.Cookie:
      return `${j(t, "User", "Active role")} cookie`;
    case E.Header:
      return `${j(t, "Authorization", "x-active-role")} header`;
    default:
      throw new Error(`Unsupported source, ${e}!`);
  }
}
function j(e, t, r) {
  switch (e) {
    case "token":
      return t;
    case "active role":
      return r;
    default:
      throw new Error(`Unsupported credential kind!, ${e}`);
  }
}
function x(e) {
  return `${e ? ` ${e}` : ""}`;
}
const ye = {
  sourceAndKindToString: J,
  appendMessage: x
}, ot = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ConfigurationRequiredError: Pe,
  CredentialKind: v,
  CredentialRequiredError: g,
  FailureResponseError: R,
  RequestError: ve,
  RequiredConfiguration: K,
  __internal: ye,
  intoFailureResponseError: b
}, Symbol.toStringTag, { value: "Module" }));
function Ie(e) {
  return ge(e), e.data;
}
function ge(e) {
  if (!I(e, function(t) {
    return typeof t == "number";
  }))
    throw new Error(
      `Expected refresh data to be a wrapped number but received ${JSON.stringify(e)}!`
    );
}
const it = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  refreshFromResponse: Ie
}, Symbol.toStringTag, { value: "Module" }));
function Q(e) {
  be(e);
  const { data: t } = e;
  return t;
}
function be(e) {
  if (!I(e, (t) => typeof t == "string"))
    throw new Error(
      "API response did not contain the expected data payload of the encoded token as a string!"
    );
}
const st = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  tokenFromApi: Q
}, Symbol.toStringTag, { value: "Module" }));
var H = /* @__PURE__ */ ((e) => (e.Student = "student", e.Guardian = "guardian", e.Teacher = "teacher", e.DistrictAdmin = "district-admin", e.SchoolAdmin = "school-admin", e.GmDis = "gm-dis", e.GmPs = "gm-ps", e.GmStaff = "gm-staff", e.GmAuthor = "gm-author", e.GmSuperAdmin = "gm-super-admin", e.GmGcstAgent = "gm-dcst", e))(H || {}), W = /* @__PURE__ */ ((e) => (e.CurriculumEntitlements = "entitlements.curricula", e.StandardsSetEntitlements = "entitlements.standards", e))(W || {});
function Fe(e) {
  return o(e, "userID", s) && o(e, "districtID", s) && o(e, "roles", m(s)) && o(e, "activeRole", s, !0) && o(e, "districtName", s) && o(e, "firstName", s) && o(e, "lastName", s) && o(e, "username", s) && o(e, "entitlements", de);
}
function Se(e) {
  if (!I(e, Fe))
    throw new Error(
      `API response was not the expected shape! ${JSON.stringify(e, void 0, 2)}`
    );
}
function $e(e) {
  return Object.values(H).includes(e);
}
function F(e) {
  if (e !== void 0 && !$e(e))
    throw new Error(`"${e}" is not recognized as a supported user role!`);
}
function Ue(e) {
  for (const t of e)
    F(t);
}
function Oe(e) {
  const { curricula: t, standards: r } = e;
  return {
    curricula: ke(t),
    standards: Ne(r)
  };
}
function ke(e) {
  return {
    ...e,
    isFull() {
      return xe(this);
    }
  };
}
function Ne(e) {
  return {
    ...e,
    isFull() {
      return He(this);
    }
  };
}
function xe(e) {
  return e.tag === T;
}
function He(e) {
  return e.tag === T;
}
function C(e, t, r, n) {
  const { requestFn: i } = r, { riplApiUrl: c } = n, { entitlements: u, ...l } = e, A = Ce(t, r, n), _ = Ve(t, i, c), h = je(t, n, r);
  return {
    ...l,
    entitlements: Oe(u),
    load: async function(a) {
      return await A(this, a);
    },
    getAttenuatedToken: async function() {
      return await _(this);
    },
    setActiveRole: async function(a) {
      return await h(this, a);
    },
    checkCurriculaAuthorized(...a) {
      const {
        entitlements: { curricula: f }
      } = this, p = f.data.map((d) => d.id);
      return a.every((d) => p.includes(d));
    },
    checkAddOnsAuthorized(a, ...f) {
      const {
        entitlements: { curricula: p }
      } = this;
      if (p.tag === T) {
        const d = p.data.find((L) => a === L.id);
        if (!d)
          return !1;
        const P = d.addOns.map((L) => L.id);
        return f.every((L) => P.includes(L));
      } else {
        const d = p.data.find((P) => a === P.id);
        return d ? f.every((P) => d.addOns.includes(P)) : !1;
      }
    },
    checkStandardsAuthorized(...a) {
      const {
        entitlements: { standards: f }
      } = this, p = f.tag === T ? f.data.map((d) => d.id) : f.data;
      return a.every((d) => p.includes(d));
    },
    toHeaders() {
      return this.credential ? {
        Authorization: `Bearer ${this.credential.raw}`,
        "x-active-role": this.activeRole
      } : {};
    }
  };
}
function Ce(e, t, r) {
  const { load: n } = e;
  if (n === void 0)
    throw new Error("The load link must be provided in the links argument!");
  return async function(c, u) {
    return await Z(
      e,
      c.credential ? { credential: c.credential, activeRole: c.activeRole } : null,
      t,
      { ...r, loadOptions: u }
    );
  };
}
function Ve({ attenuate: e }, t, r) {
  return async function(i) {
    if (e === void 0)
      throw new Error(
        "This method, getAttenuatedToken, cannot be used in m2m calls! The implementation relies on an API endpoint         that can only be called from the browser because it expects our auth cookies which are absent in m2m calls."
      );
    const c = `${r}${e}`;
    try {
      const [u, l] = await t(c, y.Get, i.credential);
      if (u == 200)
        return Q(l);
      throw new R(r, u, l);
    } catch (u) {
      throw b(c, u);
    }
  };
}
function je(e, t, r) {
  const { role: n } = e;
  return async function(c, u) {
    if (c.credential)
      throw new Error(
        "This method, setActiveRole, cannot be used in m2m calls! The implementation relies on an API endpoint         that can only be called from the browser because it expects our auth cookies which are absent in m2m calls."
      );
    const { riplApiUrl: l } = t, { requestFn: A, setterFn: _ } = r, h = `${l}${n}/${u}`;
    try {
      const [a, f] = await A(h, y.Get, c.credential);
      if (a == 200) {
        const p = V(f), d = C(p, e, r, t);
        return _(d), d;
      } else
        throw new R(h, a, f);
    } catch (a) {
      throw b(h, a);
    }
  };
}
const qe = O, ze = `${q}${O}`, De = z, Ge = D, Me = "self", Be = "load", Xe = "attenuate", Ke = "role";
function Je(e, t, r, n) {
  const i = e === E.Cookie ? t() : r();
  if (i === void 0)
    throw new g(e, v.ActiveRole, n);
  return F(i), i;
}
function Qe(e, t, r, n) {
  const i = e === E.Cookie ? t() : r();
  if (i === void 0)
    throw new g(e, v.Token, n);
  return i;
}
function We(e) {
  if (e === void 0)
    throw new g(
      E.Header,
      v.Token,
      "A credential is required in order to set the Authorization header on the request!"
    );
}
function Ye(e) {
  if (e === void 0)
    throw new g(
      E.Header,
      v.ActiveRole,
      "An active role is required in order to set the x-active-role header on the request!"
    );
}
function Ze(e) {
  return e === E.Cookie ? {
    load: qe,
    role: Ge,
    attenuate: De
  } : {
    load: ze
  };
}
function V(e) {
  Se(e);
  const { data: t } = e, {
    credential: r,
    userID: n,
    activeRole: i,
    districtID: c,
    districtName: u,
    username: l,
    firstName: A,
    lastName: _,
    roles: h,
    entitlements: a
  } = t, { curricula: f, standards: p } = a;
  return F(i), Ue(h), {
    credential: r,
    userID: n,
    districtID: c,
    districtName: u,
    username: l,
    firstName: A,
    lastName: _,
    activeRole: i,
    roles: h,
    entitlements: {
      curricula: k(f),
      standards: N(p)
    }
  };
}
async function Y(e, t, r, n) {
  const { credential: i, activeRole: c } = t ?? {}, { loadOptions: u, riplApiUrl: l } = n, A = `${l}${e.load}${ee("?", u)}`;
  try {
    const [_, h] = await r(A, y.Get, i, c);
    if (_ == 200)
      return V(h);
    throw new R(A, _, h);
  } catch (_) {
    throw b(A, _);
  }
}
async function Z(e, t, r, n) {
  const { requestFn: i, setterFn: c } = r, u = await Y(e, t, i, n), l = C(u, e, r, n);
  return c(l), l;
}
function ee(e, t) {
  return t !== void 0 && t.length > 0 ? `${e}expand=${t == null ? void 0 : t.join(",")}` : "";
}
function et(e) {
  const t = $(e, Me), r = $(e, Be), n = S(e, Xe), i = S(e, Ke);
  return {
    self: t,
    load: r,
    attenuate: n,
    role: i
  };
}
const at = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LoadOption: W,
  Role: H,
  assertIsRole: F,
  defaultLinks: Ze,
  dehydratedUserFromApi: V,
  extractAndValidateActiveRole: Je,
  extractAndValidateRawToken: Qe,
  linksFromApi: et,
  loadDehydratedUser: Y,
  loadOptsIntoExpandParameter: ee,
  loadUser: Z,
  rehydrateUser: C,
  validateRequestCredential: We,
  validateRequestRole: Ye
}, Symbol.toStringTag, { value: "Module" })), te = "bare", T = "full", ct = "x-active-role";
var E = /* @__PURE__ */ ((e) => (e.Cookie = "cookie", e.Header = "header", e))(E || {});
export {
  te as BARE,
  E as CredentialSource,
  T as FULL,
  ct as X_ACTIVE_ROLE,
  tt as api,
  nt as entitlements,
  ot as error,
  rt as guards,
  it as refresh,
  st as token,
  at as user
};
